export function classnames(names) {
    return Object
        .keys(names)
        .map(key => names[key] ? key : '')
        .join(' ')
}